<div class="affcode-selector-container">
  <div class="row hidden-xs">
    <div class="col-sm-5">
      <h4>
        {{ 'revenue.revenue-item-multi-selector.avail-revenue-items' | translate | titlecase }}
      </h4>
    </div>

    <div class="col-sm-offset-2 col-sm-5">
      <h4>
        {{ 'revenue.revenue-item-multi-selector.selected-revenue-items' | translate | titlecase }}
      </h4>
    </div>
  </div>

  <div class="form-group">
    <div class="col-sm-5">
      <h4 class="hidden-sm hidden-md hidden-lg">
        {{ 'revenue.revenue-item-multi-selector.avail-revenue-items' | translate | titlecase }}
      </h4>
      <div class="wl-revenue-item-multi-selector-box">
        <ul class="list-unstyled">
          <li
            class="wl-revenue-item-multi-selector-item-name"
            [class.bg-primary]="revenueItem.Selected"
            *ngFor="let revenueItem of revenueItems"
            (click)="toggleSelected(revenueItem)"
          >
            {{ revenueItem.ItemName }}
          </li>
        </ul>
      </div>
    </div>

    <div class="col-sm-2">
      <p class="hidden-xs text-center">
        <button pButton type="button" class="btn btn-default" icon="pi pi-chevron-right" (click)="addRevenueItems()"></button>
      </p>

      <p class="hidden-xs text-center">
        <button pButton type="button" class="btn btn-default" icon="pi pi-chevron-left" (click)="removeRevenueItems()"></button>
      </p>

      <p class="hidden-xs text-center">
        <button
          pButton
          type="button"
          class="btn btn-default f-wb"
          style="color: #fff"
          [label]="'revenue.revenue-item-multi-selector.all-dues-items' | translate | uppercase"
          (click)="addDuesItems()"
        ></button>
      </p>

      <p class="hidden-xs text-center">
        <button
          pButton
          type="button"
          class="btn btn-default f-wb"
          style="color: #fff"
          [label]="'revenue.revenue-item-multi-selector.all-non-dues-items' | translate | uppercase"
          (click)="addNonDuesItems()"
        ></button>
      </p>

      <p class="wl-revenue-item-multi-selector-button-mobile hidden-sm hidden-md hidden-lg">
        <button pButton type="button" class="btn btn-default" icon="pi pi-chevron-down" (click)="addRevenueItems()"></button>

        <button pButton type="button" class="btn btn-default" icon="pi pi-chevron-up" (click)="removeRevenueItems()"></button>
      </p>
    </div>

    <div class="col-sm-5">
      <h4 class="hidden-sm hidden-md hidden-lg">
        {{ 'revenue.revenue-item-multi-selector.selected-revenue-items' | translate | titlecase }}
      </h4>
      <div class="wl-revenue-item-multi-selector-box">
        <ul class="list-unstyled">
          <li
            *ngFor="let revenueItem of selectedRevenueItems"
            class="wl-revenue-item-multi-selector-item-name"
            [class.bg-primary]="revenueItem.Selected"
            (click)="toggleSelected(revenueItem)"
          >
            {{ revenueItem.ItemName }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
